<header>
  <nav>
    <button mat-icon-button>
      <mat-icon class="menu-icon" (click)="toggleSidenav()">menu</mat-icon>
    </button>    
    
    <div fxHide fxShow.lt-md="true" class="header__logo">
      <img src={{logo}} class="logo">
    </div>

    <div fxShow.lt-md="false">
      <button mat-icon-button [matMenuTriggerFor]="accountMenu">
        <mat-icon class="menu-icon">account_circle</mat-icon>
      </button>
      <mat-menu class="menu" #accountMenu="matMenu">
        <button mat-menu-item [routerLink]="['/users/details']" [queryParams]="{id: userLogged.id}">
          <mat-icon>supervisor_account</mat-icon>
          <span>{{userLogged.name}}</span>
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon>power_settings_new</mat-icon>
          <span>Sair</span>
        </button>
      </mat-menu>
    </div>
  </nav>
</header>